<i18n>
{
"en": {
  "DRIVERS": "Drivers",
  "MANAGEDRIVER": "Manage Driver",
  "DRIVERID": "Driver ID",
  "LICENCE": "Licence",
  "EDITDRIVER": "Edit Driver",
  "ADDNEWDRIVER": "Add New Driver",
  "DRIVERSLICENSE": "Driver's License",
  "DRIVERNAME": "Driver Name",
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "GENDER": "Gender",
  "LOADING": "Loading...",
  "UPLOADIMAGE": "Upload Image",
  "SAVEIMAGE": "Save Image",
  "MALE": "Male",
  "FEMALE": "Female",
  "IDNUMBER": "ID Number",
  "IDEXPIRATIONDATE": "ID Expiration Date",
  "PICKADATE": "Pick a date",
  "NATIONALITY": "Nationality",
  "PLEASESELECTNATIONALITY": "Please select nationality",
  "CONTACTINFO": "Contact Info",
  "MOBILENO": "Mobile No",
  "EMAILADDRESS": "Email Address",
  "LANDLINEPHONE": "Landline Phone",
  "CLICKTOUPLOAD": "Click to upload",
  "JPGPNGFILES": "jpg/png files with a size less than 400kb",
  "LICENSEEXPIRATIONDATE": "License Expiration Date",
  "TRIPS": "Trips",
  "VIOLATION": "Violation",
  "ERROR": "Error",
  "CLOSE": "Close",
  "LICENCEIMAGE": "Licence Image",
  "ISREQUIRED": "is required.",
  "MUSTBEATLEASTCHARACTERSINLENGTH": "must be at least {len} characters in length.",
  "MUSTCONTAINAVALIDEMAILADDRESS": "must contain a valid email address.",
  "CANNOTEXCEEDCHARACTERSINLENGTH": "cannot exceed {len} characters in length.",
  "ISNOTAVALIDFORMAT": "is not a valid format. Only letters, spaces and dashes are allowed.",
  "ISNOTAVALIDARABICFORMAT": "is not a valid arabic format.",
  "ALREADYEXISTED": "already existed.",
  "ROUTES": "Routes",
  "BUSNUMBER": "Bus Number",
  "NAME": "Name",
  "SUPERVISOR": "Supervisor",
  "EDITROUTE": "Edit Route",
  "FILEISTOOLARGERMAXFILEIS": "File is too large, max file is {len}.",
  "TYPEERROR": "File extensions should be {len}.",
  "LICENSEIMAGE": "License Image"
},
"ar": {
  "DRIVERS": "السائقين",
  "MANAGEDRIVER": "إدارة السائقين",
  "DRIVERID": "رقم السائق",
  "LICENCE": " رخصة",
  "EDITDRIVER": "تحرير السائق",
  "ADDNEWDRIVER": "اضافة سائق جديد",
  "DRIVERSLICENSE": "رخصة السياقة",
  "DRIVERNAME": "اسم السائق",
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "FATHERNAME": "اسم الاب",
  "FATHERNAME(ARABIC)": "اسم الأب (عربي) ",
  "LASTNAME(ARABIC)": "الإسم العائلي(عربي) ",
  "FIRSTNAME": "الأسم الأول",
  "LASTNAME": "الإسم العائلي",
  "GENDER": "جنس",
  "LOADING": "جار التحميل...",
  "UPLOADIMAGE": "تحميل الصور",
  "SAVEIMAGE": "احفظ الصورة",
  "MALE": " ذكر",
  "FEMALE": "أنثى",
  "IDNUMBER":"رقم الهوية",
  "IDEXPIRATIONDATE": "انتهاء صلاحية الهوية",
  "PICKADATE":"اختر تاريخا",
  "NATIONALITY": "الجنسية",
  "PLEASESELECTNATIONALITY": "يرجى تحديد الجنسية",
  "CONTACTINFO": "معلومات الاتصال",
  "MOBILENO": "رقم الجوال",
  "EMAILADDRESS": "عنوان البريد الإلكتروني",
  "LANDLINEPHONE": "الهاتف الثابت",
  "CLICKTOUPLOAD": "اظغط للتحميل",
  "JPGPNGFILES": " .  KB بحجم  اقل من 400 JPG/PNG ملفات ",
  "LICENSEEXPIRATIONDATE": "تاريخ انتهاء الرخصة",
  "TRIPS": " رحلات",
  "VIOLATIONS": "انتهاكات",
  "ERROR": "خطأ",
  "CLOSE": "أغلق",
  "LICENCEIMAGE": "صورة الرخصة",
  "ISREQUIRED": ".مطلوب",
  "MUSTBEATLEASTCHARACTERSINLENGTH": ".يجب أن تكون على الأقل {len} حرفا",
  "MUSTCONTAINAVALIDEMAILADDRESS": ".يجب أن يحتوي على عنوان بريد إلكتروني صالح",
  "CANNOTEXCEEDCHARACTERSINLENGTH": ".لا يمكن أن يتجاوز {len} حرفا",
  "ISNOTAVALIDFORMAT": ".ليس شكل صحيح. فقط خطابات، ويسمح للمسافات وشرطات",
  "ISNOTAVALIDARABICFORMAT": ".ليست صيغة عربية صحيحة"  ,
  "ALREADYEXISTED": ".موجودة بالفعل",
  "ROUTES": "خطوط السير",
  "BUSNUMBER": "رقم الحافلة",
  "NAME": "الاسم",
  "SUPERVISOR": "المشرفة",
  "EDITBUS": "تحرير الحافلة",
  "FILEISTOOLARGERMAXFILEIS": "ملحقات الملفات يجب أن تكون {len}.",
  "TYPEERROR": "ملحقات الملفات يجب أن تكون {len}.",
  "EDITROUTE": "تحرير خط السير",
  "LICENSEIMAGE": "صورة الترخيص"
}
}  
</i18n>
<template>
  <div class="form" v-loading="loading" :element-loading-text="$t('LOADING')">

    <el-card class="card-border" ref="card" :body-style="{ padding: 0 }">
    <wi-save slot="header" :form="['mainForm','contactForm','LicenseForm']" :title="$t('MANAGEDRIVER')" :data="{person: this.person, driver: this.driver, contact: this.contact}"></wi-save>      
    <el-row>
      <el-col :span="10">

        <el-tabs type="border-card" class="formTab tabs"  v-bind:style="{ height: cardHeight + 'px' }">
      <VuePerfectScrollbar  ref="Scrollbar" class="scrollbar"  v-bind:style="{ height: cardHeight + 'px' }">
          <el-form ref="mainForm" :model="person" label-width="120px" label-position="top">

            <el-row :gutter="20">
              <el-col :span="12">
                <wi-upload :person="person"></wi-upload>   
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('GENDER')" prop="Gender" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'change'}">
                  <el-radio-group size="small" v-model="person.Gender">
                    <el-radio-button label="Male">{{$t('MALE')}}</el-radio-button>
                    <el-radio-button label="Female">{{$t('FEMALE')}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME')" prop="FirstName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.FirstName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FIRSTNAME(ARABIC)')" prop="FirstName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.FirstName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME')" prop="MiddleName" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.MiddleName"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('FATHERNAME(ARABIC)')" prop="MiddleName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.MiddleName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME')" prop="LastName_EN" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.LastName_EN"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item :label="$t('LASTNAME(ARABIC)')" prop="LastName_AR" :rules="[{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'},{max:64, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 64}), trigger:'blur'},{validator:nameValidation, trigger:'blur'}]">
                  <el-input v-model="person.LastName_AR"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('IDNUMBER')" prop="ExternalPersonID" :rules="[{required:true, message:$t('ISREQUIRED'), trigger:'blur'},{validate: true, message: $t('IDNUMBER') + ' ' + $t('ALREADYEXISTED')},{min:2, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 2}), trigger:'blur'}]">
                  <el-input  v-model="person.ExternalPersonID"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('IDEXPIRATIONDATE')" prop="IDExpiration" :rules="{type:'date', required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" :format="date_format" :picker-options="pickerOption" v-model="person.IDExpiration" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">

              <el-col :span="12">
                <el-form-item :label="$t('NATIONALITY')" prop="Nationality" :rules="{required: true, message:$t('ISREQUIRED'), trigger:'change'}">
                  <el-select   v-model="person.Nationality" :placeholder="$t('PLEASESELECTNATIONALITY')" filterable>
                     <el-option :key="key" v-for="(value, key) in $countries" :label="value" :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          </VuePerfectScrollbar>
        </el-tabs>
      </el-col>
      <el-col :span="14">
        <el-tabs type="border-card" @tab-click="getTabData"  class="formTab"  v-bind:style="{ height: cardHeight + 'px' }">
          <el-tab-pane :label="$t('CONTACTINFO')">
            <el-form ref="contactForm" :model="contact" label-width="120px" label-position="top">
              <el-row :gutter="20" style="padding:15px">
                <el-col :span="8">
                  <el-form-item :label="$t('MOBILENO')" prop="MobilePhone" :rules="[{required: true, message:$t('ISREQUIRED'), trigger:'blur'},{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }]">
                    <el-input v-model="contact.MobilePhone"></el-input>
                  </el-form-item>
                </el-col>


                <el-col :span="8">
                  <el-form-item :label="$t('EMAILADDRESS')" prop="EMail" :rules="[{min:6, message:$t('MUSTBEATLEASTCHARACTERSINLENGTH', {len: 6}), trigger:'blur'},{type:'email', message:$t('MUSTCONTAINAVALIDEMAILADDRESS'), trigger:'blur'},{max:50, message:$t('CANNOTEXCEEDCHARACTERSINLENGTH', {len: 50}), trigger:'blur'},{validate: true, message: $t('EMAILADDRESS') + ' ' + $t('ALREADYEXISTED')}]">
                    <el-input  v-model="contact.EMail"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="$t('LANDLINEPHONE')" prop="LandlinePhone" :rules="{validator:phoneValidation, message:$t('INVALIDPHONENO'), trigger:'blur' }">
                    <el-input v-model="contact.LandlinePhone"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane :label="$t('DRIVERSLICENSE')">
          <el-row  style="padding:15px">
            <el-form ref="LicenseForm" :model="driver" label-width="120px" label-position="top">

            <el-col :span="16">
              <el-upload
                accept="image/*"
                :before-upload="beforeUpload"
                :on-change="uploadValidation"
                :data="{folder: 'license'}"
                :with-credentials="true"
                :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
                :action="URL + 'media/upload'"
                :on-success="uploadedFile">
                <el-form-item :label="$t('LICENSEIMAGE')" prop="LicenseImage" :rules="{required:true, message:$t('ISREQUIRED'), trigger: 'blur,change'}"><el-button @click="uploadValidation" slot="label" size="small" type="primary">{{$t('CLICKTOUPLOAD')}}</el-button></el-form-item>
                <div slot="tip" class="el-upload__tip">{{$t('JPGPNGFILES')}}</div>
              </el-upload>

              <div style="margin-top:15px">
                <img v-if="driver.LicenseImage!=null" style="display: block;max-width: 100%;height: auto;"  :src="getAsset(driver.LicenseImage, 'license')" />
                <i v-if="driver.LicenseImage==null" class="fa fa-id-card-o" style="font-size: 18em;"></i>
              </div>
            </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('LICENSEEXPIRATIONDATE')" prop="LicenseExpiration" :rules="{type: 'date', required: true, message:$t('ISREQUIRED'), trigger:'blur,change'}">
                  <el-date-picker type="date" :placeholder="$t('PICKADATE')" :format="date_format" :picker-options="pickerOption" v-model="driver.LicenseExpiration" style="width: 100%"></el-date-picker>
                </el-form-item>
              </el-col>
              </el-form>
          </el-row>


          </el-tab-pane>
          <el-tab-pane :label="$t('ROUTES')" name="route" v-if="person.PersonID!=null">
        <el-row calss="tab-table-margin"> 
        <el-table
        v-loading="loadingRoutes" 
        :element-loading-text="$t('LOADING')"
        :data="routes"
        highlight-current-row
        :height="cardHeight"
        stripe
        style="width: 100%">
        <el-table-column
          :label="$t('NAME')"
          show-overflow-tooltip
          min-width="180"
          class="left"
        >
          <template slot-scope="scope">
            <el-tag style="display:block; text-align:center;"  v-bind:style="'background-color:' + scope.row.RouteColor">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})" style="color:#fff; padding:0">{{scope.row.TourName}}</el-button>
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="BusNumber"
          :label="$t('BUSNUMBER')"
          min-width="120"
          align="left"
          sortable>
        </el-table-column>


        <el-table-column
          :label="$t('SUPERVISOR')"
          min-width="200"
          align="left"
          sortable>
          <template slot-scope="scope">
            <img :src="getAsset(scope.row.MonitorPhoto)" alt="" class="img-circle">
            {{_FullName({NameEN: scope.row.MonitorFullName_EN, NameAR: scope.row.MonitorFullName_AR})}}
          </template>
        </el-table-column>

        <el-table-column
          label=""
          align="right"
          min-width="40"
          class="actions">
          <template slot-scope="scope">
            <el-tooltip :content="$t('EDITROUTE')" placement="top">
              <el-button type="text" @click="$router.push({path:'/transportation/route/'+scope.row.TourID})"><i class="fa fa-pencil"></i></el-button>
            </el-tooltip>            
          </template>
        </el-table-column>
      </el-table>
          </el-row> 
          </el-tab-pane>
          <el-tab-pane :label="$t('VIOLATION')" v-if="false">{{$t('VIOLATION')}}</el-tab-pane>


        </el-tabs>
      </el-col>
    </el-row>
        </el-card>
          <el-dialog
  :title="$t('ERROR')"
  v-model="error"
  size="tiny">

  <div class="el-alert el-alert--error">
    <i class="el-alert__icon el-icon-circle-cross is-big"></i>
    <div class="el-alert__content">
      <span class="el-alert__title is-bold" :key="index" v-for="(messageError, index) in message" v-html="printError(messageError)"></span>
      </div>
   </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="error = false">{{$t('CLOSE')}}</el-button>
  </span>
</el-dialog>
  </div>
</template>
<script>
  
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import WiUpload from '@/components/dialogs/Upload'
  import WiSave from '@/components/dialogs/Save'
  export default {
    components: {VuePerfectScrollbar, 'wi-upload': WiUpload, 'wi-save': WiSave},
    data () {
      return {
        person: {PersonID: null, IDExpiration: null, Gender: null, Nationality: null, ImagePath: null},
        driver: {LicenseExpiration: null, LicenseImage: null},
        contact: {},
        routes: [],
        activeIndex: '',
        handleSelect: '',
        dialogVisible: false,
        dialogImageUrl: '',
        cardHeight: 0,
        loading: false,
        message: null,
        error: false,
        loadingRoutes: false,
        date_format: 'dd/MM/yyyy',
        pickerOption: {
          disabledDate (time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        alreadyExisted: {ID: false, Email: false}
      }
    },
    mounted () {
      this.switchLanguage()
      this.cardHeight = window.innerHeight - this.$refs.card.$el.children[0].offsetHeight - 53
      this.getDriver()
    },
    methods: {
      printError (message) {
        let error = message.split(' ')
        if (error.length > 2) return this.$t(error[0]) + ' ' + this.$t(error[1], {len: error[2]}) + '</br>'
        return this.$t(error[0]) + ' ' + this.$t(error[1]) + '</br>'
      },
      phoneValidation (rule, value, callback) {
        let regex = /^\+?[\d-]+$/
        if (value && !regex.test(value)) callback(this.$t('INVALIDPHONENO'))
        callback()
      },
      imageUploaded (res) {
        if (res.file_name !== undefined) this.person.ImagePath = res.file_name
      },
      getDriver () {
        let self = this
        if (this.$route.params.id === 'create') return
        this.loading = true
        this.$http.get('/driver/' + this.$route.params.id).then(function (response) {
          self.person = response.data.person
          self.person.IDExpiration = self.dateFormat(self.person.IDExpiration)
          self.driver = response.data.driver
          self.driver.LicenseExpiration = self.dateFormat(self.driver.LicenseExpiration)
          self.contact = response.data.contact
          self.loading = false
        }).catch(function (response) {})
      },
      onSubmit () {
        console.log('submit!')
      },
      handleAvatarSuccess (res, file) {
        this.student.ImagePath = URL.createObjectURL(file.raw)
      },
      beforeUpload (file) {
        const isJPG = file.type.split('/')[0] === 'image'
        const isLt2KB = file.size / 1024 < 400
        this.message = {}
        if (!isJPG) {
          this.message['type'] = ' TYPEERROR png,gif,jpeg,jpg'
        }
        if (!isLt2KB) {
          this.message['size'] = ' FILEISTOOLARGERMAXFILEIS 400KB'
        }
        if (Object.keys(this.message).length !== 0) this.error = true
        return isJPG && isLt2KB
      },
      uploadedFile (response, file, fileList) {
        this.driver.LicenseImage = response.file_name
      },
      uploadValidation () {
        this.$refs.LicenseForm.validateField('LicenseImage')
      },
      getRoute () {
        let self = this
        if (self.routes.length !== 0) return
        self.loadingRoutes = true
        this.$http.get('/route/assigned?BusDriverID=' + self.driver.BusDriverID)
          .then(function (response) {
            self.loadingRoutes = false
            self.routes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getTabData (tab) {
        switch (tab.name) {
          case 'route':
            this.getRoute()
            break
        }
      }
    }
  }
</script>

<style>


</style>




// WEBPACK FOOTER //
// DriverManage.vue?0b337d9e